import React from 'react';
import styled from 'styled-components';
import { Input } from '../../../../shared/componentsV2/Input';
import { HandleUploadPdf, PdfUploader } from './PdfUploader';

const OutlinedArea = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  margin: 0;
  background-color: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme }) => theme.colors.black};
  border-radius: 0.5rem;
`;

export function GenerateFormTemplateInputs({
  className,
  handleUpload,
  isProcessingImage,
  startedProcessingAt,
  formTemplateSlug,
  setFormTemplateSlug,
}: {
  handleUpload: HandleUploadPdf;
  isProcessingImage: boolean;
  startedProcessingAt?: Date;
  className?: string;
  formTemplateSlug: string;
  setFormTemplateSlug: (slug: string) => void;
}) {
  return (
    <OutlinedArea className={className}>
      <Input
        label="Form template slug"
        name="slug"
        value={formTemplateSlug}
        onChange={(e) => setFormTemplateSlug(e.target.value)}
        required
      />
      <PdfUploader
        handleUpload={handleUpload}
        isProcessingImage={isProcessingImage}
        startedProcessingAt={startedProcessingAt}
      />
    </OutlinedArea>
  );
}
